import { useEffect, useState } from "react";
import { baseURL, basics } from "../../basics";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Ui/Loading";
import { Link } from "react-router-dom";
import { MdOutlineInsertComment } from "react-icons/md";
import { FaTruck } from "react-icons/fa";
import { shopInfoActions } from "../../store/shopInfo-slice";
const OverallInfo = () => {
  const dispatch = useDispatch();
  const data = useSelector((state: any) => state.shopInfo.shopInfoData);
  // console.log("data", data);
  const shopInfoDataResponse = useSelector(
    (state: any) => state.shopInfo.received
  );
  const dataInShopInfo = data.stores[0];

  const currentDate = new Date();
  let currentDayOfWeek = currentDate.getDay();
  currentDayOfWeek = currentDayOfWeek !== 0 ? currentDayOfWeek : 7;
  const findCurrentDayInfo = dataInShopInfo.activities.find(
    (activity: any) => activity.day === currentDayOfWeek
  );
  const tomorrowDayOfWeek = currentDayOfWeek !== 7 ? currentDayOfWeek + 1 : 1;
  const findTomorrowInfo = dataInShopInfo.activities.find(
    (activity: any) => activity.day === tomorrowDayOfWeek
  );
  // console.log(
  //   "check today info",
  //   currentDayOfWeek,
  //   tomorrowDayOfWeek,
  //   findCurrentDayInfo,
  //   findTomorrowInfo
  // );
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();

  // Format the time with leading zeros if needed
  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;

  // console.log(formattedTime); // Output: "10:30" (example)

  const checkPeriodActivitiyFrom = findCurrentDayInfo.fromTime
    .split(":")
    .slice(0, 2)
    .join(":");
  const checkPeriodActivitiyTo = findCurrentDayInfo.toTime
    .split(":")
    .slice(0, 2)
    .join(":");
  const checkDayesIsDayOff = findCurrentDayInfo.isDayOff;
  const checkTomorrowIsDayOff = findTomorrowInfo.isDayOff;

  const currentDateOfUser = new Date();
  currentDateOfUser.setHours(
    Number(formattedTime.split(":")[0]),
    Number(formattedTime.split(":")[1]),
    0,
    0
  );

  const dateFrom = new Date();
  dateFrom.setHours(
    Number(checkPeriodActivitiyFrom.split(":")[0]),
    Number(checkPeriodActivitiyFrom.split(":")[1]),
    0,
    0
  );
  const dateTo = new Date();
  dateTo.setHours(
    Number(checkPeriodActivitiyTo.split(":")[0]),
    Number(checkPeriodActivitiyTo.split(":")[1]),
    0,
    0
  );

  const checkPeriodTimeAvailableHandler =
    dateFrom <= currentDateOfUser && currentDateOfUser <= dateTo;
  // all conditions:
  //1:
  // checkDayesIsDayOff && checkPeriodTimeAvailableHandler && checkTomorrowIsDayOff >>نداریم
  // checkDayesIsDayOff && checkPeriodTimeAvailableHandler && !checkTomorrowIsDayOff >>نداریم
  // 2.1:
  // !checkDayesIsDayOff && !checkPeriodTimeAvailableHandler && !checkTomorrowIsDayOff >> رزرو مثال آخر شب یکشنبه ای تعطیل
  // !checkDayesIsDayOff && !checkPeriodTimeAvailableHandler && !checkTomorrowIsDayOff >> رزرو مثال از 00:00 تا dateFrom صبح یکشنبه ای رزرو
  // !checkDayesIsDayOff && !checkPeriodTimeAvailableHandler && checkTomorrowIsDayOff >> بسته مثال پنجشنبه آخر شب
  // 2.2:
  // !checkDayesIsDayOff && checkPeriodTimeAvailableHandler (&& !checkTomorrowIsDayOff) >> یاز مثال پنجشنبه در طول روز کاری
  // !checkDayesIsDayOff && checkPeriodTimeAvailableHandler (&& checkTomorrowIsDayOff )>> باز مثال روز های کاری هفته
  // 3:
  // checkDayesIsDayOff (&& !checkPeriodTimeAvailableHandler) && !checkTomorrowIsDayOff >>رزرو مثال جمعه
  // checkDayesIsDayOff (&& !checkPeriodTimeAvailableHandler) && checkTomorrowIsDayOff >> بسته مثال در جمعه ای که شنبه هم تعطیله
  const checkOpenCloseReserveStore = () => {
    // 2:

    if (!checkDayesIsDayOff) {
      // 2.1:
      if (!checkPeriodTimeAvailableHandler) {
        if (!checkTomorrowIsDayOff) {
          return "رزرو";
        } else {
          if (dateFrom > currentDateOfUser && currentDateOfUser <= dateTo) {
            return "رزرو";
          }
          return "بسته";
        }
      }
      // 2.2:
      if (checkPeriodTimeAvailableHandler) {
        return "باز";
      }
    }
    // 3:
    if (checkDayesIsDayOff) {
      if (!checkTomorrowIsDayOff) {
        return "رزرو";
      } else {
        return "بسته";
      }
    }
    return "بسته";
  };
  // console.log("checkOpenCloseReserveStore", checkOpenCloseReserveStore());
  // const checkOpenCloseReserveStore =
  //   !checkDayesIsDayOff && checkPeriodTimeAvailableHandler
  //     ? "باز"
  //     : !checkTomorrowIsDayOff
  //     ? "رزرو"
  //     : "بسته";
  dispatch(
    shopInfoActions.changeOpenCloseReserveStore(checkOpenCloseReserveStore())
  );
  // console.log(
  //   "findCurrentDayInfo",
  //    formattedTime,
  //    checkPeriodActivitiyTo,
  //   checkPeriodTimeAvailableHandler,
  //   checkDayesIsDayOff,
  //   checkOpenCloseReserveStore
  // );

  if (Object.keys(data).length === 0) {
    return <Loading />;
  }

  const statusText = checkOpenCloseReserveStore();
  const statusStyles: { [key: string]: { dot: string; label: string } } = {
    باز: { dot: "bg-emerald-400", label: "باز است" },
    بسته: { dot: "bg-rose-400", label: "بسته است" },
    رزرو: { dot: "bg-amber-400", label: "فقط رزرو سفارش" },
  };
  const currentStatus = statusStyles[statusText] ?? statusStyles["بسته"];

  return (
    <div className="absolute inset-0">
      {/* Text block is pinned to the physical left edge explicitly (not via
          normal block flow) because this app is dir="rtl": an in-flow block
          would anchor to the inline-start edge (the right, same side as the
          image/badge below) and collide with them instead of sitting on the left. */}
      <div className="absolute top-0 left-0 z-10 flex max-w-[62%] flex-col gap-5 p-4 sm:max-w-[56%] sm:gap-6 sm:p-6">
        <div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-extrabold text-white leading-snug">
            {dataInShopInfo.title || "شرکت میوه کانی باغ سنه دژ"}
          </h2>
          <Link
            to="/sendAndHowCalculatePayments"
            className="flex items-center gap-1.5 mt-2 w-fit text-xs  sm:text-sm text-zinc-100 hover:text-white transition"
          >
            <FaTruck className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" />
            <span>{basics.sendAndHowCalculatePayments}</span>
          </Link>
        </div>
        <Link
          to="/getStoreComments"
          className="inline-flex items-center gap-1.5 w-fit rounded-full bg-white px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold text-emerald-700 shadow-sm hover:bg-emerald-50 transition"
        >
          <MdOutlineInsertComment className="w-4 h-4 sm:w-5 sm:h-5" />
          {basics.seeCustomersComment}
        </Link>
      </div>

      <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 z-10 min-w-[84px] rounded-xl bg-black/50 backdrop-blur-sm px-2.5 py-1.5 sm:px-3 sm:py-2 text-white">
        <div className="flex items-center gap-1 text-[12px] sm:text-[16px] font-semibold whitespace-nowrap">
          <span className={`w-1.5 h-1.5 rounded-full ${currentStatus.dot}`}></span>
          {currentStatus.label}
        </div>
        {!checkDayesIsDayOff && checkPeriodTimeAvailableHandler && (
          <div className="mt-1 text-[10px] sm:text-[14px] text-white leading-tight whitespace-nowrap">
            <div>{basics.activitiesPeriod}</div>
            <div className="font-medium text-white">
              {checkPeriodActivitiyFrom} {basics.until} {checkPeriodActivitiyTo}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OverallInfo;
